import { ExpertiseWidgetStrategy } from '../ExpertiseWidgetStrategy';
import { columnDefs } from './expertiseNighthawkColumns';
import { WidgetType } from 'widgets/WidgetType';
import { expertiseWidgetStrategyCommon } from 'widgets/expertise/expertiseWidgetStrategyCommon';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { streamConfig } from 'widgets/expertise/store/stream/stream-config';
import Expertise from 'widgets/expertise/Expertise';

export const expertiseNighthawkWidgetStrategy: ExpertiseWidgetStrategy = {
    title: 'Expertise Nighthawk',
    reactComponentType: Expertise,
    reportType: 'Nighthawk',
    buildColumnDefs: columnDefs,
    categories: [WidgetCategory.SINGLE_STOCK],
    streamConfigs: [streamConfig(WidgetType.EXPERTISE_NIGHTHAWK, 'Nighthawk')],
    ...expertiseWidgetStrategyCommon,
};
